// extracted by mini-css-extract-plugin
export default {"container":"XD-z","dimension":"YD-z","dimensionLabels":"ZD-z"};